document.addEventListener("DOMContentLoaded",function() {
   const figures = document.getElementsByClassName("figures__figure");

   if(figures.length) {
      function figureCounter() {
         // For each figure block
         for (let i = 0; i < figures.length; i++) {
            // Assign initial animation delay
            let delay = 1000;
            let delayMilliseconds = 500;
            // Get the number columns with the box
            let numberCols = figures[i].getElementsByClassName('number-column');
            // Set up an array of numbers 0 through 9
            const numbers = Array(10).fill(0).map((n, i) => n + i);

            for (let c = 0; c < numberCols.length; c++) {
               for (let n = 0; n < numbers.length; n++) {
                  // Print out numbers 0 through 9 within each number column
                  numberCols[c].innerHTML += '<p class="number">'+numbers[n]+'</p>';
               }

               // Get the value of each number column and alter -em margin to match
               let countTo = 0;
               if (window.innerWidth < 1240) {
                  countTo = numberCols[c].getAttribute('data-value')*34;
               } else {
                  countTo = numberCols[c].getAttribute('data-value')*100;
               }

               delay = i*delayMilliseconds;
               setTimeout(function() {
                  numberCols[c].children[0].style.marginTop = "-"+countTo+"px";
               }, delay);

            }
         }
      }
      figureCounter();

      // Listen for the AJAX request, when complete, re-trigger the figureCounter
      var oldXHR = window.XMLHttpRequest;
      function newXHR() {
         var realXHR = new oldXHR();
         realXHR.addEventListener("readystatechange", function() {
            if(realXHR.readyState == 4 && realXHR.status == 200){
               setTimeout(function() {
                  figureCounter();
               }, 100)
            }
         }, false);
         return realXHR;
      }
      window.XMLHttpRequest = newXHR;
   }
});